module.exports = __webpack_public_path__ + "static/img/08.c66f2d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2024111/08.png
// module id = nL4N
// module chunks = 0